import { FC } from "preact/compat";
import { Outlet } from "react-router-dom";
import { getMe } from "~/core";

const Admin: FC = () => {
    const { role } = getMe();

    if (role.value !== "admin") {
        return null;
    }

    return <Outlet />;
};

export default Admin;
